import { SR_API_ACTION_UTILITY_PARTNER_RENTVINE_UNIT_TYPES_GET } from 'api/utilityActionTypes';

import { buildGetPmsUnitTypesAction } from './pmsUnitTypes.shared';

export default buildGetPmsUnitTypesAction(SR_API_ACTION_UTILITY_PARTNER_RENTVINE_UNIT_TYPES_GET);
